import { useState, useEffect } from "react";
import PromoteursHeader from "./PromoteursHeader";
import PromoteursBody from "./PromoteursBody";
import PromoteursAdminBody from "./PromoteursAdminBody";
import { useDispatch, useSelector } from "react-redux";
import {
  getPromoteurs,
  getSecteurs,
} from "../../../redux/actions/promoteursActions";
import Pagination from "../../../components/commons/Pagination";

const PromoteursList = () => {
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.userAuthReducer);
  const [searchfilter, setSearchfilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    field: "updatedAt",
    direction: "desc"
  });
  const { promoteurs, loading, secteurs } = useSelector(
    (state) => state.promoteursReducer
  );
  const { user } = useSelector((state) => state.userAuthReducer);
  useEffect(() => {
    dispatch(getSecteurs());
    dispatch(getPromoteurs(currentPage, 25, searchfilter, sortConfig.field, sortConfig.direction));
  }, [currentPage, dispatch, searchfilter, sortConfig.field, sortConfig.direction]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemSearch = () => {
    dispatch(getPromoteurs(1, 25, searchfilter, sortConfig.field, sortConfig.direction));
  };
  
  const handleSort = (field, direction) => {
    setSortConfig({ field, direction });
    setCurrentPage(1); // Reset to first page when sorting changes
  };

  if (loading || !promoteurs?.data) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <div>
      <PromoteursHeader
        searchfilter={searchfilter}
        setSearchfilter={setSearchfilter}
        handleItemSearch={handleItemSearch}
      />
      {user.profile === "Administrateur" ||
      (user.profile === "Collaborateur" && user.createPromoter) ? (
        <PromoteursAdminBody 
          listePromoteurs={promoteurs} 
          secteurs={secteurs} 
          onSort={handleSort}
          sortConfig={sortConfig}
        />
      ) : (
        <PromoteursBody listePromoteurs={promoteurs} secteurs={secteurs} />
      )}
      {promoteurs?.meta?.pagination?.pageCount > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={promoteurs.meta.pagination.pageCount}
          onPageChange={handlePageChange}
          className="mt-20"
        />
      )}
    </div>
  );
};

export default PromoteursList;
